var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{ref:"videoBox",style:({'width':_vm.config.width,'height':_vm.config.height}),attrs:{"width":_vm.config.width,"height":_vm.config.height,"id":("videoBox_" + _vm.random),"loop":_vm.config.loop,"controls":_vm.config.controls,"controlslist":_vm.config.videoControls},domProps:{"muted":_vm.config.muted}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3425e30e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/video.vue
// module id = null
// module chunks = 